import {
  Box,
  Checkbox,
  Chip,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./style.module.css";

/**
 * Multi select that renders the picked years as removable chips inside the
 * field, the way the Year filter is drawn in the design.
 */
const YearMultiSelect = ({
  options = [],
  formData = {},
  onUpdate = () => {},
  name = "year",
  labelKey = "name",
  valueKey = "id",
  defaultText = "Select Year",
}) => {
  const selected = Array.isArray(formData[name]) ? formData[name] : [];

  const handleChange = (event) => {
    onUpdate(name, event.target.value);
  };

  const handleDelete = (value) => {
    onUpdate(
      name,
      selected.filter((item) => item !== value)
    );
  };

  return (
    <Select
      fullWidth
      multiple
      size="small"
      displayEmpty
      name={name}
      value={selected}
      onChange={handleChange}
      className={styles.year_select}
      renderValue={(picked) => {
        if (!picked || picked.length === 0) {
          return <em className={styles.placeholder}>{defaultText}</em>;
        }
        return (
          <Box className={styles.chip_wrap}>
            {options
              .filter((option) => picked.includes(option[valueKey]))
              .map((option) => (
                <Chip
                  key={option[valueKey]}
                  size="small"
                  label={option[labelKey]}
                  className={styles.year_chip}
                  deleteIcon={<CloseIcon />}
                  // stop the click from opening the dropdown
                  onMouseDown={(event) => event.stopPropagation()}
                  onDelete={() => handleDelete(option[valueKey])}
                />
              ))}
          </Box>
        );
      }}
    >
      {options.map((option) => (
        <MenuItem key={option[valueKey]} value={option[valueKey]}>
          <Checkbox
            size="small"
            checked={selected.indexOf(option[valueKey]) > -1}
          />
          <ListItemText primary={option[labelKey]} />
        </MenuItem>
      ))}
    </Select>
  );
};

export default YearMultiSelect;
